import React from 'react';
import './Skeleton.css';

/** Generic skeleton block */
export function Skeleton({ width, height, style, className = '' }) {
  return (
    <div
      className={`skeleton ${className}`}
      style={{ width, height, ...style }}
    />
  );
}

/** Skeleton text line */
export function SkeletonText({ size = 'long' }) {
  return <div className={`skeleton skeleton-text ${size}`} />;
}

/** Skeleton that mimics the portfolio table while loading */
export function SkeletonPortfolioTable({ rows = 6 }) {
  return (
    <div className="skeleton-portfolio-table">
      <div className="skeleton-table-header">
        <div className="skeleton" />
        <div className="skeleton" />
        <div className="skeleton" />
        <div className="skeleton" />
        <div className="skeleton" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton-table-row">
          <div className="skeleton skeleton-symbol" />
          <div className="skeleton" style={{ flex: 2 }} />
          <div className="skeleton skeleton-badge" />
          <div className="skeleton skeleton-badge" />
          <div className="skeleton skeleton-badge" />
          <div className="skeleton skeleton-badge" />
        </div>
      ))}
    </div>
  );
}

/** Skeleton that mimics the dashboard charts */
export function SkeletonDashboard() {
  return (
    <div className="skeleton-card">
      <Skeleton width="200px" height="1.25rem" style={{ marginBottom: '1.5rem' }} />
      <div className="skeleton-dashboard">
        <div className="skeleton skeleton-donut" />
        <div className="skeleton skeleton-donut" />
      </div>
    </div>
  );
}

/** Skeleton for score summary cards */
export function SkeletonScores({ count = 4 }) {
  return (
    <div className="skeleton-card">
      <div className="skeleton-scores">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="skeleton-score-item">
            <Skeleton className="skeleton-score-value" />
            <Skeleton className="skeleton-score-label" />
          </div>
        ))}
      </div>
    </div>
  );
}

/** Generic card skeleton */
export function SkeletonCard({ lines = 3 }) {
  return (
    <div className="skeleton-card">
      <div className="skeleton skeleton-heading" />
      {Array.from({ length: lines }).map((_, i) => (
        <SkeletonText key={i} size={i === lines - 1 ? 'short' : i % 2 === 0 ? 'long' : 'medium'} />
      ))}
    </div>
  );
}
